module.exports = __webpack_public_path__ + "media/error.0141b4f2.wav";